import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { EventBus } from "../../../eventbus";
import { map } from "../../../functions/HelperFuncs";
import { upload } from "../../../functions/Upload";
import { baseUrl } from "../../../config";

//Use css filters to preview te results
//for export add the canvas filters to the image before saving

export default {
  props: {
    file: Object,
  },
  components: {
    VueCropper,
  },
  data() {
    return {
      opperationPrefix: "file-editor-preview",
      maxWidth: false,
      maxHeight: false,
      isCropping: false,
      dims: {
        width: 0,
        height: 0,
      },
      imgSettings: {
        scale: [1, 1],
        rotate: [0],
      },
      imgFilters: {
        brightness: {
          value: 0,
          min: 0,
          max: 2,
          inMin: -100,
          inMax: 100,
          ext: "",
        },
        contrast: {
          value: 0,
          min: 0,
          max: 200,
          inMin: -100,
          inMax: 100,
          ext: "%",
        },
        "hue-rotate": {
          value: 0,
          min: 0,
          max: 360,
          inMin: 0,
          inMax: 360,
          ext: "deg",
        },
        saturate: {
          value: 0,
          min: 100,
          max: 0,
          inMin: 0,
          inMax: 100,
          ext: "%",
        },
        blur: {
          value: 0,
          min: 0,
          max: 60,
          inMin: 0,
          inMax: 60,
          ext: "px",
        },
      },
      isCropping: false,
    };
  },
  created() {
    EventBus.$on(`${this.opperationPrefix}--flip-horizontal`, () =>
      this.handleFlipHorizontal()
    );
    EventBus.$on(`${this.opperationPrefix}--flip-vertical`, () =>
      this.handleFlipVertical()
    );

    EventBus.$on(`${this.opperationPrefix}--rotate-left`, () =>
      this.handleRotateLeft()
    );
    EventBus.$on(`${this.opperationPrefix}--rotate-right`, () =>
      this.handleRotateRight()
    );

    EventBus.$on(`${this.opperationPrefix}--brightness`, (e) =>
      this.handleSetBrightness(e)
    );
    EventBus.$on(`${this.opperationPrefix}--contrast`, (e) =>
      this.handleSetContrast(e)
    );

    EventBus.$on(`${this.opperationPrefix}--hue`, (e) => this.handleSetHue(e));
    EventBus.$on(`${this.opperationPrefix}--saturation`, (e) =>
      this.handleSetSaturation(e)
    );

    EventBus.$on(`${this.opperationPrefix}--blur`, (e) =>
      this.handleSetBlur(e)
    );

    EventBus.$on(`${this.opperationPrefix}--reset`, () =>
      this.handleResetAll()
    );

    EventBus.$on(`${this.opperationPrefix}--download`, () =>
      this.handleDownload()
    );

    EventBus.$on(`${this.opperationPrefix}--save`, () => this.handleSave());

    EventBus.$on(`${this.opperationPrefix}--set-dims`, this.handleSetImageSize);

    EventBus.$on(`${this.opperationPrefix}--create`, () =>
      this.handleCreateCrop()
    );
    EventBus.$on(`${this.opperationPrefix}--remove`, () =>
      this.handleRemoveCrop()
    );

    EventBus.$on(`${this.opperationPrefix}--set-ratio`, (ratio) =>
      this.handleSetRatio(ratio)
    );

    window.addEventListener("resize", this.handleRemoveCrop);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleRemoveCrop);
  },
  methods: {
    handleChangeCrop() {
      if (this.$refs.cropper) {
        const canvas = this.$refs.cropper.getCroppedCanvas();

        EventBus.$emit(`image-dimensions--set-dims`, {
          width: canvas.width,
          height: canvas.height,
        });
      }
    },
    handleSetRatio(ratio = NaN) {
      if (this.$refs.cropper) {
        this.$refs.cropper.setAspectRatio(ratio);
      }
    },

    handleCreateCrop() {
      if (this.$refs.cropper) {
        const elem = this.$refs.cropper.$el;

        this.handleSetRatio();

        this.isCropping = true;
        this.$refs.cropper.setCropBoxData({
          top: elem.offsetHeight * 0.1,
          left: elem.offsetWidth * 0.1,
          width: elem.offsetWidth * 0.8,
          height: elem.offsetHeight * 0.8,
        });

        this.handleChangeCrop();
      }
    },
    handleRemoveCrop() {
      if (this.$refs.cropper) {
        const elem = this.$refs.cropper.$el;

        this.handleSetRatio();

        this.isCropping = false;
        this.$refs.cropper.setCropBoxData({
          top: 0,
          left: 0,
          width: elem.offsetWidth,
          height: elem.offsetHeight,
        });

        this.handleChangeCrop();
      }
    },
    handleLoaded() {
      if (this.$refs.wrapper) {
        const canvas = this.$refs.wrapper.querySelector(".cropper-canvas");
        this.dims = {
          width: canvas.offsetWidth,
          height: canvas.offsetHeight,
        };
      }
    },
    handleSetImageSize(dims) {
      this.maxWidth = dims.width;
      this.maxHeight = dims.height;
    },
    handleResetAll() {
      this.imgSettings = {
        scale: [1, 1],
        rotate: [0],
      };
      this.imgFilters = {
        brightness: {
          value: 0,
          min: 0,
          max: 2,
          inMin: -100,
          inMax: 100,
          ext: "",
        },
        contrast: {
          value: 0,
          min: 0,
          max: 200,
          inMin: -100,
          inMax: 100,
          ext: "%",
        },
        "hue-rotate": {
          value: 0,
          min: 0,
          max: 360,
          inMin: 0,
          inMax: 360,
          ext: "deg",
        },
        saturate: {
          value: 0,
          min: 100,
          max: 0,
          inMin: 0,
          inMax: 100,
          ext: "%",
        },
        blur: {
          value: 0,
          min: 0,
          max: 60,
          inMin: 0,
          inMax: 60,
          ext: "px",
        },
      };

      this.preformActions();
      this.setFilters();

      EventBus.$emit(`file-editor-tools--reset`);
    },

    handleDownload() {
      const canvas = this.createImage();

      if (canvas) {
        canvas.toBlob((blob) => {
          const link = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `${this.file.name}.png`;
          link.click();
          window.URL.revokeObjectURL(url);
        });
      }
    },

    handleSave() {
      const canvas = this.createImage();

      if (canvas) {
        canvas.toBlob((blob) => {
          upload(
            {
              folderId: this.file.folder_id,
              files: [blob],
              fileNames: [`${this.file.name}_edit.png`],
              myspace: this.file.myspace,
            },
            this
          );
        });
      }
    },

    createImage() {
      if (this.$refs.cropper) {
        const canvas = this.$refs.cropper.getCroppedCanvas({
          maxWidth: this.maxWidth ? this.maxWidth : Infinity,
          maxHeight: this.maxHeight ? this.maxHeight : Infinity,
        });
        const ctx = canvas.getContext("2d");

        let result = "";

        Object.keys(this.imgFilters).forEach((filter) => {
          const filterItems =
            filter === "blur" ? this.calcBlurScale() : this.imgFilters[filter];

          result += `${filter}(${map(
            filterItems.value,
            filterItems.inMin,
            filterItems.inMax,
            filterItems.min,
            filterItems.max
          )}${filterItems.ext}) `;
        });

        ctx.filter = result;

        ctx.drawImage(canvas, 0, 0);

        return canvas;
      }

      return false;
    },

    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.file.myspace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    handleCropperReady() {
      EventBus.$emit("file-full--loading-done");

      this.handleLoaded();
    },

    calcBlurScale() {
      const img = this.$refs.cropper.$el.querySelector(".cropper-canvas img");
      const result = {
        value: this.imgFilters.blur.value,
        min: 0,
        max: 60,
        inMin: 0,
        inMax: 60,
        ext: "px",
      };

      if (img) {
        result.max = map(img.naturalWidth, 0, img.offsetWidth, 0, result.max);
      }

      return result;
    },
    handleCropStart() {
      this.isCropping = true;
      this.setFilters();
    },
    setFilters() {
      if (this.$refs.cropper) {
        let result = "";

        Object.keys(this.imgFilters).forEach((filter) => {
          const filterItems = this.imgFilters[filter];

          result += `${filter}(${map(
            filterItems.value,
            filterItems.inMin,
            filterItems.inMax,
            filterItems.min,
            filterItems.max
          )}${filterItems.ext}) `;
        });

        result += "";

        const canvasImg = this.$refs.cropper.$el.querySelector(
          ".cropper-canvas img"
        );
        const viewBoxImg = this.$refs.cropper.$el.querySelector(
          ".cropper-view-box img"
        );

        if (canvasImg && viewBoxImg) {
          viewBoxImg.style.filter = `${result}`;
          canvasImg.style.filter = ``;
        }
      }
    },

    preformActions() {
      if (this.$refs.cropper) {
        Object.keys(this.imgSettings).forEach((setting) => {
          switch (this.imgSettings[setting].length) {
            case 1:
              this.$refs.cropper[setting](this.imgSettings[setting][0]);
              break;

            case 2:
              this.$refs.cropper[setting](
                this.imgSettings[setting][0],
                this.imgSettings[setting][1]
              );
              break;

            default:
              this.$refs.cropper[setting]();
              break;
          }
        });
      }
    },
    setNewImgFilter(key, value) {
      this.imgFilters = {
        ...this.imgFilters,
        [key]: {
          ...this.imgFilters[key],
          value,
        },
      };
    },

    resetTransforms() {
      this.imgSettings = {
        ...this.imgSettings,
        rotate: [0],
      };
    },

    handleFlipHorizontal() {
      this.resetTransforms();
      this.imgSettings.scale[0] = this.imgSettings.scale[0] === 1 ? -1 : 1;

      this.preformActions();
    },
    handleFlipVertical() {
      this.resetTransforms();
      this.imgSettings.scale[1] = this.imgSettings.scale[1] === 1 ? -1 : 1;

      this.preformActions();
    },

    rotationSizingFix() {
      if (this.$refs.cropper) {
        this.$refs.cropper.zoomTo(0);
      }
    },

    handleRotateLeft() {
      this.imgSettings.rotate[0] = -90;
      this.rotationSizingFix();
      this.preformActions();
    },
    handleRotateRight() {
      this.imgSettings.rotate[0] = 90;
      this.rotationSizingFix();
      this.preformActions();
    },

    handleSetBrightness(b) {
      this.setNewImgFilter("brightness", b);
      this.setFilters();
    },
    handleSetContrast(c) {
      this.setNewImgFilter("contrast", c);
      this.setFilters();
    },

    handleSetHue(h) {
      this.setNewImgFilter("hue-rotate", h);
      this.setFilters();
    },
    handleSetSaturation(s) {
      this.setNewImgFilter("saturate", s);
      this.setFilters();
    },
    handleSetBlur(b) {
      this.setNewImgFilter("blur", b);
      this.setFilters();
    },
  },
  computed: {
    basicStyle() {
      return {
        maxWidth: this.based + "px",
      };
    },
  },
  watch: {
    wrapperDim() {},
  },
};
